import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { setPageSEO } from "@/lib/seo";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import { CheckCircle2 } from "lucide-react";

export default function ContactoGracias() {
  useEffect(() => {
    setPageSEO({
      title: "¡Mensaje recibido! | Carlos Garcín · Professional EOS Implementer",
      description: "Confirmación de envío del formulario de contacto de Carlos Garcín, Professional EOS Implementer.",
      path: "/contacto-gracias",
      robots: "noindex, nofollow",
    });
    window.scrollTo(0, 0);

    if (typeof window.oaiq === "function") {
      window.oaiq("measure", "appointment_scheduled", { type: "customer_action" });
    }
  }, []);

  return (
    <>
      <Header />
      <main data-testid="contacto-gracias-page">
        <section className="bg-white pt-36 pb-24 lg:pt-44 lg:pb-32">
          <div className="container-eos">
            <div className="max-w-xl mx-auto text-center">
              <div className="mx-auto w-16 h-16 rounded-full bg-[#F26522]/10 flex items-center justify-center">
                <CheckCircle2 className="w-8 h-8 text-[#F26522]" strokeWidth={1.8} />
              </div>
              <h1 className="mt-6 font-display font-extrabold text-3xl sm:text-4xl text-navy-800">
                ¡Mensaje recibido!
              </h1>
              <p className="mt-4 text-lg text-slate-600 leading-relaxed">
                Recibí tu mensaje, me pondré en contacto contigo en un par de horas. ¡Gracias!
              </p>
              <Link
                to="/"
                data-testid="gracias-volver-inicio"
                className="btn-primary mt-8 inline-flex"
              >
                Volver al inicio
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}
